import { getImageUri, Images } from "../assets/Images";

export const getAvatarSource = (uri, gender, isUndefined = false) => {
	if (Boolean(uri)) {
		return {
			uri
		};
	}

	if (isUndefined) {
		return;
	}

	switch (gender) {
		case "M":
			return getImageUri("avatar");
		case "F":
			return getImageUri("avatarF");
		default:
			return getImageUri("avatarU");
	}
};

export const getAvatarSourceUri = (uri, gender) => {
	if (uri) {
		return uri;
	}

	switch (gender) {
		case "M":
			return Images.avatar;
		case "F":
			return Images.avatarF;
		default:
			return Images.avatarU;
	}
};
